import React from 'react';
import SubPage from './SubPage';
import { useLang } from '../LanguageContext';

const T = {
  lede: { ko: '이 페이지는 준비 중입니다.', en: 'This page is being prepared.' },
  body: { ko: '리뉴얼 시안을 순서대로 이식하고 있습니다. 준비되면 이 자리에 내용이 들어갑니다.',
          en: 'We are porting the redesigned pages in order. Content will appear here once ready.' },
};

// 시안 이식이 끝나면 각 페이지 컴포넌트로 하나씩 교체된다.
// crumb/title 은 {ko,en} 객체로 받는다 — 문자열로 받으면 영문 모드에서 한글이 남는다.
function Pending({ crumb, title }) {
  const { lang } = useLang();
  const pick = (v) => (v && typeof v === 'object' ? v[lang] || v.ko : v);
  return (
    <SubPage crumb={pick(crumb)} title={pick(title)} lede={T.lede[lang]}>
      <p className="sp-prose">{T.body[lang]}</p>
    </SubPage>
  );
}

export default Pending;
